import { Switch } from "react-router-dom";
import GestaoAcordosCobranca from "../../Pages/Cobranca/GestaoAcordosCobranca";
import { GestaoAtendimentosCobranca } from "../../Pages/Cobranca/GestaoAtendimentos";
import FilaAtendimentos from "../../Pages/Cobranca/GestaoAtendimentos/FilaAtendimentos";
import GestaoCarteiraCobranca from "../../Pages/Cobranca/GestaoCarteira";
import RelatoriosCobranca from "../../Pages/Cobranca/Relatorios";
import RelatoriosBICobranca from "../../Pages/Cobranca/Relatorios/RelatoriosBI";
import { ACESSOS } from "../Acessos";
import PrivatedRoute from "../PrivatedRoute";
import Atendimento from "../../Pages/Cobranca/Atendimento";
import { GestaoTitulos } from "../../Pages/Cobranca/GestaoTitulos";
import DescontoAlcadaCobranca from "../../Pages/Cobranca/Atendimento/AlcadaDescontoCobranca";
import ModeloRenegociacaoGrupo from "../../Pages/Cobranca/ModeloRenegociacaoGrupo";
import Serasa from "../../Pages/Cobranca/Serasa";

export default function RotasCobranca() {
    return (
        <Switch>
            <PrivatedRoute
                path={ACESSOS.COBRANCA.TELAS.GESTAO_ATENDIMENTOS.TODOS.DS_PATH}
                component={GestaoAtendimentosCobranca.TodosAtendimentosCobranca}
                isPrivate
                idModulo={ACESSOS.COBRANCA.ID_MODULO}
            />
            <PrivatedRoute
                path={
                    ACESSOS.COBRANCA.TELAS.GESTAO_ATENDIMENTOS.USUARIO.DS_PATH
                }
                component={GestaoAtendimentosCobranca.MeusAtendimentosCobranca}
                isPrivate
                idModulo={ACESSOS.COBRANCA.ID_MODULO}
            />
            <PrivatedRoute
                path={ACESSOS.COBRANCA.TELAS.GESTAO_ATENDIMENTOS.GRUPO.DS_PATH}
                component={GestaoAtendimentosCobranca.GrupoAtendimentosCobranca}
                isPrivate
                idModulo={ACESSOS.COBRANCA.ID_MODULO}
            />
            <PrivatedRoute
                path={ACESSOS.COBRANCA.TELAS.FILA_ATENDIMENTOS.DS_PATH}
                component={FilaAtendimentos}
                isPrivate
                idModulo={ACESSOS.COBRANCA.ID_MODULO}
                idTela={ACESSOS.COBRANCA.TELAS.FILA_ATENDIMENTOS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.COBRANCA.TELAS.ATENDIMENTO.DS_PATH}
                component={Atendimento}
                isPrivate
                idModulo={ACESSOS.COBRANCA.ID_MODULO}
                idTela={ACESSOS.COBRANCA.TELAS.ATENDIMENTO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.COBRANCA.TELAS.DASHBOARD.DS_PATH}
                component={() => <></>}
                isPrivate
                idModulo={ACESSOS.COBRANCA.ID_MODULO}
                idTela={ACESSOS.COBRANCA.TELAS.DASHBOARD.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.COBRANCA.TELAS.GESTAO_ACORDOS.DS_PATH}
                component={GestaoAcordosCobranca}
                isPrivate
                idModulo={ACESSOS.COBRANCA.ID_MODULO}
                idTela={ACESSOS.COBRANCA.TELAS.GESTAO_ACORDOS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.COBRANCA.TELAS.RENEGOCIACAO_GRUPO.DS_PATH}
                component={ModeloRenegociacaoGrupo}
                isPrivate
                idModulo={ACESSOS.COBRANCA.ID_MODULO}
                idTela={ACESSOS.COBRANCA.TELAS.RENEGOCIACAO_GRUPO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.COBRANCA.TELAS.CAPYS_BI.DS_PATH}
                component={RelatoriosBICobranca}
                isPrivate
                idModulo={ACESSOS.COBRANCA.ID_MODULO}
                idTela={ACESSOS.COBRANCA.TELAS.CAPYS_BI.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.COBRANCA.TELAS.DISTRIBUICAO_CARTEIRA.DS_PATH}
                component={GestaoCarteiraCobranca}
                isPrivate
                idModulo={ACESSOS.COBRANCA.ID_MODULO}
                idTela={ACESSOS.COBRANCA.TELAS.DISTRIBUICAO_CARTEIRA.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.COBRANCA.TELAS.RELATORIO_CONTATO.DS_PATH}
                component={RelatoriosCobranca}
                isPrivate
                idModulo={ACESSOS.COBRANCA.ID_MODULO}
                idTela={ACESSOS.COBRANCA.TELAS.RELATORIO_CONTATO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.COBRANCA.TELAS.GESTAO_TITULOS.DS_PATH}
                component={GestaoTitulos}
                isPrivate
                idModulo={ACESSOS.COBRANCA.ID_MODULO}
                idTela={ACESSOS.COBRANCA.TELAS.GESTAO_TITULOS.ID_TELA}
            />

            <PrivatedRoute
                path={ACESSOS.COBRANCA.TELAS.ALCADA_DESCONTO.DS_PATH}
                component={DescontoAlcadaCobranca}
                isPrivate
                idModulo={ACESSOS.COBRANCA.ID_MODULO}
                idTela={ACESSOS.COBRANCA.TELAS.ALCADA_DESCONTO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.COBRANCA.TELAS.SERASA.DS_PATH}
                component={Serasa}
                isPrivate
                idModulo={ACESSOS.COBRANCA.ID_MODULO}
                idTela={ACESSOS.COBRANCA.TELAS.SERASA.ID_TELA}
            />
        </Switch>
    );
}
